// True when the app runs inside an iframe, which is how the ICON platform embeds it.
// A cross-origin parent throws on window.top access, which also means "in an iframe".
const detectIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export const IS_IN_IFRAME = detectIframe();
